var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.perfil)?_c('div',{staticClass:"supporter"},[_c('Header'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Status')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }